<template>
    <div></div>
</template>
<script>
export default {
    name: 'meal',
}
</script>